import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/stats/users/me/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const me = {
  get: apiPathFunc(pathBase),
} as const;
